<template>
    <div>
        <a-modal 
        v-model="visible" 
        @ok="handleOk" 
        :width="iphone_screen" 
        :footer="null" 
        :dialog-style="{ top: '5px' }" 
        :class="this.$i18n.locale=='tc'?'font-NotoSansTC':'font-roboto'"
        :maskClosable="false">
            <template slot="title">
                <div id="modalTitle" v-html="$t('collectingInformation.oursuppliers2')" :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb8'"></div>
            </template>
            <div class="stepComponent" v-show="this.current!==3">
                <a-steps :current="current" :direction="direction">
                    <a-step>
                        <template slot="title">
                            {{ $t('collectingInformation.aboutcompany') }}
                        </template>
                    <span slot="description">{{ $t('collectingInformation.aboutbusiness') }}</span>
                    </a-step>
                    <a-step :title="$t('collectingInformation.aboutproduct')" :description="$t('collectingInformation.understandneeds')" />
                    <a-step :title="$t('collectingInformation.contactfun')" :description="$t('collectingInformation.contactyou')" />
                </a-steps>
            </div>
            <div class="tip" v-show="this.current!==3">
                {{ $t('collectingInformation.chancesgrowth') }}
            </div>
            <div class="submitTip" v-show="this.current==3">
                <h2 :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb7'">{{ $t('collectingInformation.confirmsubmit') }}</h2>
                <span v-html="$t('collectingInformation.followinginformation')"></span>
            </div>
            <div class="formmodal">
                <a-form-model layout="vertical" :model="form" ref="ruleForm" :rules="rules">
                    <div v-show="this.current==0||this.current==3">
                        <a-form-model-item
                        :label="$t('collectingInformation.companyname')"
                        prop="company_name"
                        >
                            <a-input v-model="form.company_name" :placeholder="$t('collectingInformation.entercompany')"/>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.enterarea')"
                        prop="company_address"
                        >
                            <div class="countryTip">{{ $t('collectingInformation.entercountrytip') }}</div>
                            <a-select
                                show-search
                                :placeholder="$t('collectingInformation.selectarea')"
                                option-filter-prop="children"
                                :filter-option="filterOption"
                                v-model="form.company_address"
                            >
                                <a-select-option :value="item.domain_code+'-'+item.name_en" v-for="(item,index) in country" :key="index">
                                    +{{ item.phone_code }} {{ item.name_en }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.yearofcompany')"
                        prop="company_create_year"
                        >
                            <a-date-picker 
                            mode="year" 
                            :placeholder="$t('collectingInformation.selectyear2')" 
                            v-model="form.company_create_year" 
                            :format="monthFormat" 
                            :open="yearShowOne"
                            :allowClear="false"
                            :disabledDate="getDisabledDate"
                            @openChange="openChangeOne"
                            @panelChange="panelChangeOne"
                            />
                            <!-- <year-picker
                                v-model="year" 
                                :year-disable="'no'"
                                @input="handlerInput" 
                            /> -->
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.companywebsite')"
                        prop="company_website"
                        >
                            <a-input v-model="form.company_website" placeholder="https://"/>
                        </a-form-model-item>
                    </div>
                    <div v-show="this.current==1||this.current==3">
                        <a-form-model-item
                        :label="$t('collectingInformation.producttypes')"
                        prop="global_or_loacal"
                        >
                            <a-checkbox-group v-model="form.global_or_loacal" @change="chengeCheckBox" class="checkBox">
                                    <a-checkbox value="1" name="type">
                                        {{ $t('collectingInformation.globalroaming') }}
                                    </a-checkbox>
                                    <div class="inBox" v-if="form.global_or_loacal.includes('1')">
                                        <a-form-model-item
                                        prop="global_options"
                                        style="margin-bottom: 0;"
                                        >
                                            <a-checkbox-group v-model="form.global_options">
                                                <a-checkbox value="1" name="type">
                                                    {{ $t('collectingInformation.onlydata') }}
                                                </a-checkbox>
                                                <a-checkbox value="2" name="type">
                                                    {{ $t('collectingInformation.datacalls') }}
                                                </a-checkbox>
                                                <a-checkbox value="3" name="type">
                                                    {{ $t('collectingInformation.datasms') }}
                                                </a-checkbox>
                                                <a-checkbox value="4" name="type">
                                                    {{ $t('collectingInformation.datacallssms') }}
                                                </a-checkbox>
                                            </a-checkbox-group>
                                        </a-form-model-item>
                                    </div>
                                <div>
                                    <a-checkbox value="2" name="type">
                                        {{ $t('collectingInformation.local') }}
                                    </a-checkbox>
                                    <div  class="inBox" v-if="form.global_or_loacal.includes('2')">
                                        <a-form-model-item
                                        prop="local_options"
                                        style="margin-bottom: 0;"
                                        >
                                            <a-checkbox-group v-model="form.local_options">
                                                <a-checkbox value="1" name="type">
                                                    {{ $t('collectingInformation.onlydata') }}
                                                </a-checkbox>
                                                <a-checkbox value="2" name="type">
                                                    {{ $t('collectingInformation.datacalls') }}
                                                </a-checkbox>
                                                <a-checkbox value="3" name="type">
                                                    {{ $t('collectingInformation.datasms') }}
                                                </a-checkbox>
                                                <a-checkbox value="4" name="type">
                                                    {{ $t('collectingInformation.datacallssms') }}
                                                </a-checkbox>
                                            </a-checkbox-group>
                                        </a-form-model-item>
                                    </div>
                                </div>
                            </a-checkbox-group>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.preferredregions')"
                        prop="advantage_product_region">
                            <a-checkbox-group v-model="form.advantage_product_region">
                                <a-checkbox value="AS" name="type">
                                    {{ $t('collectingInformation.asia') }}
                                </a-checkbox>
                                <a-checkbox value="EU" name="type">
                                    {{ $t('collectingInformation.europe') }}
                                </a-checkbox>
                                <a-checkbox value="AF" name="type">
                                    {{ $t('collectingInformation.africa') }}
                                </a-checkbox>
                                <a-checkbox value="SA" name="type">
                                    {{ $t('collectingInformation.northamerica') }}
                                </a-checkbox>
                                <a-checkbox value="NA" name="type">
                                    {{ $t('collectingInformation.southamerica') }}
                                </a-checkbox>
                                <a-checkbox value="OC" name="type">
                                    {{ $t('collectingInformation.oceania') }}
                                </a-checkbox>
                            </a-checkbox-group>
                            <div v-if="this.form.advantage_product_region.length">
                                <a-row type="flex" align="middle">
                                    <a-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
                                        {{ $t('collectingInformation.settlementurl') }}
                                    </a-col>
                                    <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                        <a-input v-model="form.quote_file_url" :disabled="fileList.length>0" :placeholder="$t('collectingInformation.entersettlementurl')"/>
                                    </a-col>
                                </a-row>
                                <div class="divider">
                                    --- {{ $t('collectingInformation.or') }} ---
                                </div>
                                <a-row type="flex" align="middle">
                                    <a-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
                                        {{ $t('collectingInformation.uploadsettlementurl') }}
                                    </a-col>
                                    <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" :class="form.quote_file_url?'disabledBtn':'defaultBtn'">
                                        <!-- <a-button type="primary">Upload</a-button> -->
                                        <a-upload
                                            @change="fileStatusChange"
                                            :fileList="fileList"
                                            :beforeUpload="beforeUpload"
                                            :customRequest="customRequest"
                                            :multiple="true"
                                            :remove="removefile"
                                            :disabled="form.quote_file_url?true:false"
                                        >
                                            <a-button > <a-icon type="upload" /> {{ $t('collectingInformation.upload') }} </a-button>
                                        </a-upload>
                                        <div class="btnTip">{{ $t('collectingInformation.uploadxlsx') }}</div>
                                    </a-col>
                                </a-row>
                            </div>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.supportapi')"
                        prop="support_api">
                            <a-radio-group v-model="form.support_api" @change="changeRadioBox">
                                <a-radio :style="radioStyle" :value="1">{{ $t('collectingInformation.yes') }}</a-radio>
                                    <div v-if="form.support_api==1">
                                        <a-row type="flex" align="middle">
                                            <a-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
                                                {{ $t('collectingInformation.apiurl') }}
                                            </a-col>
                                            <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                                <a-input v-model="form.api_doc_url" :disabled="fileList2.length>0" :placeholder="$t('collectingInformation.enterapiurl')"/>
                                            </a-col>
                                        </a-row>
                                        <div class="divider">--- {{ $t('collectingInformation.or') }} ---</div>
                                        <a-row type="flex" align="middle">
                                            <a-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
                                                {{ $t('collectingInformation.apidocument') }}
                                            </a-col>
                                            <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" :class="form.api_doc_url?'disabledBtn':'defaultBtn'">
                                                <a-upload
                                                    @change="fileStatusChange2"
                                                    :fileList="fileList2"
                                                    :beforeUpload="beforeUpload2"
                                                    :customRequest="customRequest2"
                                                    :multiple="true"
                                                    :remove="removefile2"
                                                    :disabled="form.api_doc_url?true:false"
                                                >
                                                    <a-button> <a-icon type="upload" /> {{ $t('collectingInformation.upload') }} </a-button>
                                                </a-upload>
                                                <div class="btnTip">{{ $t('collectingInformation.uploadpdf') }}</div>
                                            </a-col>
                                        </a-row>
                                    </div>
                                <a-radio :style="radioStyle" :value="2">{{ $t('collectingInformation.no') }}</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.supportcdr')"
                        prop="support_cdr">
                            <a-radio-group v-model="form.support_cdr">
                                <a-radio :style="radioStyle" :value="1">{{ $t('collectingInformation.yes') }}</a-radio>
                                <a-radio :style="radioStyle" :value="0">{{ $t('collectingInformation.no') }}</a-radio>
                            </a-radio-group>
                        </a-form-model-item>
                    </div>
                    <div v-show="this.current==2||this.current==3">
                        <a-form-model-item
                        :label="$t('collectingInformation.aboutTSim')"
                        prop="about_tsim"
                        >
                            <a-checkbox-group v-model="form.about_tsim" class="checkBox" @change="aboutType_options">
                                <div>
                                    <a-row type="flex" align="top">
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                            <a-checkbox value="1" name="type" style="margin: 0;">
                                                {{ $t('collectingInformation.socialMedia') }}
                                            </a-checkbox>
                                        </a-col>
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="this.form.about_tsim.indexOf('1') !== -1">
                                            <a-form-model-item
                                                prop="social_platform"
                                                style="margin: 0;"
                                            >
                                                <a-input v-model="form.how_to_know_tsim.social_platform.detail" :placeholder="$t('collectingInformation.entersouce')"/>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                </div>
                                <div>
                                    <a-row type="flex" align="top">
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                            <a-checkbox value="2" name="type" style="margin: 0;">
                                                {{ $t('collectingInformation.onlinePlatform') }}
                                            </a-checkbox>
                                        </a-col>
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="this.form.about_tsim.indexOf('2') !== -1">
                                            <a-form-model-item
                                                prop="third_party_ecommerce"
                                                style="margin: 0;"
                                            >
                                                <a-input v-model="form.how_to_know_tsim.third_party_ecommerce.detail" :placeholder="$t('collectingInformation.enterplatform')"/>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                </div>
                                <div>
                                    <a-row type="flex" align="top">
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                            <a-checkbox value="3" name="type" style="margin: 0;">
                                                {{ $t('collectingInformation.referral') }}
                                            </a-checkbox>
                                        </a-col>
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="this.form.about_tsim.indexOf('3') !== -1">
                                            <a-form-model-item
                                                prop="friend_recommendation"
                                                style="margin: 0;"
                                            >
                                                <a-input v-model="form.how_to_know_tsim.friend_recommendation.detail" :placeholder="$t('collectingInformation.enterreferral')"/>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                </div>
                                <div>
                                    <a-row type="flex" align="top">
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                            <a-checkbox value="4" name="type" style="margin: 0;">
                                                {{ $t('collectingInformation.other') }}
                                            </a-checkbox>
                                        </a-col>
                                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="this.form.about_tsim.indexOf('4') !== -1">
                                            <a-form-model-item
                                                prop="other_input"
                                                style="margin: 0;"
                                            >
                                                <a-input v-model="form.other_input" @change="synchro_otherInputdata" :placeholder="$t('collectingInformation.briefdescription')"/>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>
                                </div>
                            </a-checkbox-group>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.contactname')"
                        prop="contact_name"
                        >
                            <a-input v-model="form.contact_name" :placeholder="$t('collectingInformation.enteryourname')"/>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.email')"
                        prop="contact_email"
                        style="margin-bottom: 5px;"
                        >
                            
                            <a-row type="flex" align="middle">
                                <a-col :xs="24" :sm="24" :md="24" :lg="13" :xl="13">
                                    <a-input v-model="form.contact_email" :placeholder="$t('collectingInformation.enteryouremail')"/>
                                </a-col>
                                <a-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10" :class="isCountingDown?'disabledBtn':'getCodeBtn'">
                                    <a-button type="primary" v-debounce="[()=>{getCode()},1000]" :disabled="isCountingDown">
                                        {{ isCountingDown ? `${countdown} ${this.$t('collectingInformation.sec')}` : $t('collectingInformation.getcode') }}
                                    </a-button>
                                </a-col>
                            </a-row>
                        </a-form-model-item>
                        <a-form-model-item
                        prop="email_verify_code"
                        >
                            <a-input v-model="form.email_verify_code" :placeholder="$t('collectingInformation.entercode')"/>
                        </a-form-model-item>
                        <a-form-model-item
                        :label="$t('collectingInformation.phonenumber')"
                        prop="contact_phone"
                        style="margin-bottom: 10px;"
                        >
                            <a-row type="flex" align="middle">
                                <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                                    <a-select
                                        show-search
                                        :placeholder="$t('collectingInformation.areacode')"
                                        option-filter-prop="children"
                                        :filter-option="filterOption2"
                                        v-model="form.countryCode"
                                        :allowClear="true"
                                    >
                                        <a-select-option :value="item.zone+'-'+item.code" v-for="(item,index) in countryCode" :key="index+item.code">
                                            {{ '+'+item.zone }}
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
                                    <a-input v-model="form.contact_phone" :placeholder="$t('collectingInformation.enterphone')"/>
                                </a-col>
                            </a-row>
                        </a-form-model-item>
                    </div>
                    <a-form-model-item>
                        <div class="submitBtn">
                            <a-row>
                                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="backBtn">
                                    <a-button type="primary" @click="()=>{this.current--}" v-if="this.current&&this.current!==3">
                                        {{ $t('collectingInformation.back') }}
                                    </a-button>
                                </a-col>
                                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                    <a-button type="primary" v-debounce="[()=>{handleSubmit()},1000]" :loading="loading">
                                        {{ this.current==3?$t('collectingInformation.confirm'):this.current==2?$t('collectingInformation.submit'):$t('collectingInformation.next') }}
                                    </a-button>
                                </a-col>
                            </a-row>
                        </div>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </a-modal>
        <a-modal v-model="visible2"  @ok="handleOk2" :width="iphone_screen" :footer="null" :class="this.$i18n.locale=='tc'?'font-NotoSansTC':'font-roboto'">
            <template slot="title">
                <div id="modalTitle" v-html="$t('collectingInformation.oursuppliers2')" :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb8'"></div>
            </template>
            <div class="successTip">
                <p>
                <a-icon type="check-circle" :style="{ fontSize: '62px', color: '#56c568' }"/>
            </p>
            <p :style="{color: '#56c568',fontSize: '28px',fontFamily:this.$i18n.locale=='tc'?'NotoSansTC-Bold':'Roboto-Bold'}">
                {{ $t('collectingInformation.wellreceived') }}
            </p>
            <p style="font-size: 24px;">
                {{ $t('collectingInformation.keepcontact') }}
            </p>
            </div>
        </a-modal>
        <a-modal v-model="visible3"  @ok="handleOk3" :width="iphone_screen" :footer="null" :dialog-style="{ top: '5px' }" class="font-roboto">
            <template slot="title">
                <div id="modalTitle" v-html="$t('collectingInformation.oursuppliers2')" :class="this.$i18n.locale=='tc'?'titleFont_nt7':'titleFont_rb8'"></div>
            </template>
            <div>
                <h2 style="text-align: center;">Mutual Non-Disclosure Agreement</h2>
                <p>
                    This Mutual Non-Disclosure Agreement (the “Agreement”) is entered into by the undersigned parties (the “Parties”) for the purpose of protecting confidential information during negotiations related to potential cooperation (the “Transaction”).
                </p>
                <h3>
                    1. Definition of Confidential Information
                </h3>
                <p>
                    1.1 <b>Confidential Information</b> refers to any and all information disclosed by one Party (the "Disclosing Party") to the other Party (the "Receiving Party"), including but not limited to business strategies, financial data, operational methods, intellectual property, and any other proprietary information.<br/>
                    1.2 Confidential Information does not include information that is publicly available or that the Receiving Party can demonstrate was obtained from a third party without a breach of confidentiality.
                </p>
                <h3>2. Obligations of the Receiving Party</h3>
                <p>
                    2.1 The Receiving Party agrees to use the Confidential Information solely for the purpose of evaluating the Transaction and shall:
                    <ul>
                        <li>Disclose the Confidential Information only to those representatives who need to know for the Permitted Purpose;</li>
                        <li>Clearly mark any disclosed information as "Confidential";</li>
                        <li>Inform representatives of the confidential nature of the information and ensure their compliance with this Agreement;</li>
                        <li>Immediately notify the Disclosing Party of any unauthorized disclosure or use of Confidential Information.</li>
                    </ul>
                </p>
                <h3>
                    3. Non-Disclosure
                </h3>
                <p>
                    3.1 The Receiving Party shall not disclose, reproduce, or communicate any Confidential Information to any third party without the prior written consent of the Disclosing Party.<br/>
                    3.2 If required by law to disclose any Confidential Information, the Receiving Party shall limit the disclosure to the minimum necessary and shall notify the Disclosing Party prior to such disclosure.
                </p>
                <h3>
                    4. Liability for Breach
                </h3>
                <p>
                    4.1 The Receiving Party shall be liable for any damages resulting from a breach of this Agreement and shall indemnify the Disclosing Party for any losses incurred.
                </p>
                <h3>
                    5. Term and Termination
                </h3>
                <p>
                    5.1 This Agreement shall remain in effect for a term of two (2) years from the Effective Date, and the confidentiality obligations shall continue indefinitely.
                </p>
                <h3>
                    6. General Provisions
                </h3>
                <p>
                    6.1 All Confidential Information remains the property of the Disclosing Party, and the Receiving Party shall return all copies upon request.
                    6.2 The Disclosing Party makes no representations or warranties regarding the accuracy of the Confidential Information.
                    6.3 This Agreement shall be governed by the laws of the Hong Kong Special Administrative Region.
                    6.4 Any amendments to this Agreement must be made in writing and signed by both Parties.
                    6.5 Any amendments must be in writing and signed by both Parties.
                    6.6 The Receiving Party may not assign its rights or obligations without consent from the Disclosing Party.
                    6.7 Each Party will bear its own expenses related to this Agreement.
                    6.8 This Agreement shall be governed under the laws of the HKSAR.
                    6.9 Disputes will be resolved through amicable negotiations or through arbitration in accordance with Hong Kong arbitration rules, in English.
                </p>
                <p>
                    <b>
                        By checking the box below, the undersigned parties acknowledge that they have read, understood, and agree to the terms of this Mutual Non-Disclosure Agreement.
                    </b>
                </p>
            </div>
        </a-modal>
    </div>
</template>

<script>
import Axios from 'axios';
import countryCode from './phoneCode.js';
import moment from "moment";
import { getToken } from '@/api/qiniu'
import { sendSupplierEmailVerifyCode,becomeSupplier,getCountry } from '@/api/collectionInfo'
import { validateSpecialAndHttp,validateEmail,validateFiveDigitNumber,checkIsIPhone,validateURL } from '@/utils/reg'
    export default {
        data() {
            let validateCompany_name = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.entercompany')));
                }else if(!validateSpecialAndHttp(value)){
                    callback(new Error(this.$t('collectingInformation.correctcompany')));
                }else callback()
            };
            let validateCompany_address = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.selectarea')));
                }else callback()
            };
            let validateCompany_create_year = (rule, value, callback) => {                
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.selectyear')));
                }else callback()
            };
            let validateCompany_website = (rule, value, callback) => {
                if (!validateURL(value)) {
                    callback(new Error(this.$t('collectingInformation.enterwebsite')));
                }else callback()
            };
            let validateGlobal_or_loacal = (rule, value, callback) => {
                if (!value||!value.length) {
                    callback(new Error(this.$t('collectingInformation.selectprovidingtype')));
                }else callback()
            };
            let validateGlobal_options = (rule, value, callback) => {
                if (!value||!value.length) {
                    callback(new Error(this.$t('collectingInformation.selectresources')));
                }else callback()
            };
            let validateLocal_options = (rule, value, callback) => {
                if (!value||!value.length) {
                    callback(new Error(this.$t('collectingInformation.selectresources')));
                }else callback()
            };
            let validateadVantage_product_region = (rule, value, callback) => {
                if (!value||!value.length) {
                    callback(new Error(this.$t('collectingInformation.selectprefereregions')));
                }else callback()
            };
            let validateSupport_api = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.selectisapi')));
                }else callback()
            };
            let validateSupport_cdr = (rule, value, callback) => {
                if (value!==0&&value!==1) {
                    callback(new Error(this.$t('collectingInformation.selectiscdr')));
                }else callback()
            };
            let validateSales_about_tsim = (rule, value, callback) => {
                if (!value||!value.length) {
                    callback(new Error(this.$t('collectingInformation.heardaboutTSim')));
                }else callback()
            };
            let validateother = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.pleaseenter')));
                }else callback()
            };
            let validateContact_name = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.enteryourname')));
                }else if(!validateSpecialAndHttp(value)){
                    callback(new Error(this.$t('collectingInformation.correctname')));
                }else callback()
            };
            let validatecontact_email = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.enteryouremail')));
                }else if(!validateEmail(value)){
                    callback(new Error(this.$t('collectingInformation.correctemail')));
                }else callback()
            };
            let validateEmail_verify_code = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t('collectingInformation.entercode')));
                }else if(!validateFiveDigitNumber(value)){
                    callback(new Error(this.$t('collectingInformation.correctverification')));
                }else callback()
            };
            // let validateIs_agree = (rule, value, callback) => {
            //     if (!value||!value.length) {
            //         callback(new Error(this.$t('collectingInformation.confirmagreement')));
            //     }else callback()
            // };
            return {
                visible: false,
                visible2: false,
                visible3: false,
                current:0,
                direction:'horizontal',
                iphone_screen:window.innerWidth,
                queryParam:{},
                token:'',
                token2:'',
                loading:false,
                form: {
                    company_website:'',
                    contact_phone:'',
                    countryCode:undefined,
                    advantage_product_region:[],
                    global_or_loacal:[],
                    api_doc_url:'',
                    quote_file_url:'',
                    global_options:[],
                    local_options:[],
                    company_create_year:'',
                    support_cdr:undefined,
                    support_api:undefined,
                    about_tsim:[],
                    other_input:'',
                    how_to_know_tsim:{
                        social_platform:{
                            selected: false,
                            detail: ""
                        },
                        third_party_ecommerce: {
                            selected: false,
                            detail: ""
                        },
                        friend_recommendation: {
                            selected: false,
                            detail: ""
                        },
                        other: {
                            selected: false,
                            detail: ""
                        }
                    }
                },
                radioStyle: {
                    display: 'block',
                    height: '30px',
                    lineHeight: '30px',
                },
                rules: {
                    company_name: [{ required: true,validator: validateCompany_name, trigger: 'blur' },],
                    company_address: [{ required: true, validator: validateCompany_address, trigger: 'blur' }],
                    company_create_year: [{ required: true, validator: validateCompany_create_year, trigger: 'blur' }],
                    company_website: [{ validator: validateCompany_website, trigger: 'blur' },],
                    global_or_loacal: [{ required: true, validator:validateGlobal_or_loacal, trigger: 'change' }],
                    global_options: [{ required: true, validator:validateGlobal_options, trigger: 'change' }],
                    local_options: [{ required: true, validator:validateLocal_options, trigger: 'change' }],
                    advantage_product_region: [{ required: true,validator:validateadVantage_product_region, trigger: 'change' }],
                    support_api: [{ required: true, validator:validateSupport_api, trigger: 'change' }],
                    support_cdr: [{ required: true, validator:validateSupport_cdr, trigger: 'change' }],
                    contact_name: [{ required: true, trigger: 'blur',validator: validateContact_name }],
                    contact_email: [{ required: true, trigger: 'blur',validator:validatecontact_email }],
                    email_verify_code: [{ required: true, trigger: 'blur',validator:validateEmail_verify_code }],
                    contact_phone: [{ required: false, message: 'Please input activity form', trigger: 'blur' }],
                    about_tsim: [{ required: true,validator: validateSales_about_tsim, trigger: 'change' }],
                    other_input: [{ required: true, validator: validateother, trigger: 'blur' }],
                    social_platform: [{ required: false,  trigger: 'blur' }],
                    third_party_ecommerce: [{ required: false,  trigger: 'blur' }],
                    friend_recommendation: [{ required: false,  trigger: 'blur' }],
                },
                fileList:[],
                fileList2:[],
                customerSettlementInfoArray:[],
                customerAPIDocumentationInfoArray:[],
                customerfileArray:[],
                customerfileArray2:[],
                monthFormat: 'YYYY',
                countryCode,
                country:[],
                yearShowOne:false,
                year:'',
                countdown: 60,       // 倒计时秒数
                isCountingDown: false, // 控制按钮是否禁用
                timer: null           // 定时器
            };
        },
        mounted () {
            this.checkIphone()
            this.getCountryArray()
        },
        methods: {
            getCountryArray(){
                getCountry().then(res=>{
                    this.country = res.result.list
                })
            },
            showAgreement(){
                this.visible3 = true
            },
            checkIphone(){
                if(checkIsIPhone()||window.innerWidth<769){
                    this.direction = 'vertical'
                    this.iphone_screen = window.innerWidth
                }else{
                    this.direction = 'horizontal'
                    this.iphone_screen = 800
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            filterOption2(input, option) {
                return (
                    option.componentOptions.children[0].text.indexOf(input) >= 0
                );
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.visible = false;
            },
            handleOk2(e) {
                this.visible2 = false;
            },
            handleOk3(e) {
                this.visible2 = false;
            },
            handleSubmit(e){
                if(this.current==0){
                    let true_num = 0
                    if(!this.form.company_create_year){//mode改为year之后form无法直接验证，只能手动验证
                        this.$refs.ruleForm.validateField('company_create_year',(valid)=>{
                        })
                    }else{
                        true_num++
                    }
                    this.$refs.ruleForm.validateField(['company_name','company_address','company_website'],(valid) => {
                        if (!valid) {
                            true_num++
                            if(true_num>=4){
                                this.current++
                                this.$nextTick(() => {
                                    //延迟触发避免数据未加载
                                    const element = document.getElementById("modalTitle");
                                    console.log(element);
                                    
                                    element.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                    });
                                });
                            }
                        }
                    });
                }else if(this.current==1){
                    let true_num = 0
                    let requiredArray = ['global_or_loacal','advantage_product_region','support_api','support_cdr']
                    if(this.form.global_or_loacal.includes('1')){
                        requiredArray.push('global_options')
                    }
                    if(this.form.global_or_loacal.includes('2')){
                        requiredArray.push('local_options')
                    }
                    this.$refs.ruleForm.validateField(requiredArray,(valid) => {
                        if (!valid) {
                            true_num++
                            if(true_num>=requiredArray.length){
                                this.current++
                                this.$nextTick(() => {
                                    //延迟触发避免数据未加载
                                    const element = document.getElementById("modalTitle");
                                    console.log(element);
                                    
                                    element.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                    });
                                });
                            }
                        }
                    });
                }else if(this.current==2){
                    let true_num = 0
                    let requiredArray = ['about_tsim','contact_name','contact_email','email_verify_code']
                    if(this.form.about_tsim.includes('4')){
                            requiredArray.push('other_input')
                    }
                    this.$refs.ruleForm.validateField(requiredArray,(valid) => {
                        if (!valid) {
                            true_num++
                            if(true_num>=requiredArray.length){
                                this.current++
                                this.$nextTick(() => {
                                    //延迟触发避免数据未加载
                                    const element = document.getElementById("modalTitle");
                                    element.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                    });
                                });
                            }
                        }
                    });
                }else if(this.current==3){
                    this.$refs.ruleForm.validate((valid) => {
                        if (valid) {
                            this.loading = true
                            let formCopy = {};
                            formCopy = { ...this.form };
                            formCopy.countryCode = formCopy.countryCode ? formCopy.countryCode.split('-')[0] + '-' : '';
                            formCopy.company_address = formCopy.company_address.split('-')[0]
                            formCopy.contact_phone = formCopy.contact_phone?formCopy.countryCode + formCopy.contact_phone:'';
                            formCopy.is_global = formCopy.global_or_loacal.includes("1") ? 1 : 0;
                            formCopy.is_local = formCopy.global_or_loacal.includes("2") ? 1 : 0;
                            formCopy.support_api = formCopy.support_api==1?formCopy.support_api:0;
                            formCopy.support_cdr = formCopy.support_cdr?formCopy.support_cdr:0;
                            formCopy.global_options = formCopy.global_options.toString();
                            formCopy.local_options = formCopy.local_options.toString();
                            formCopy.advantage_product_region = formCopy.advantage_product_region.toString();

                            // 等待上传操作完成
                            Promise.all([this.uploadSettlement(), this.uploadAPIDocumentation()])
                                .then(() => {
                                    console.log('Promise.all 执行完毕');
                                    if(!this.form.quote_file_url){//如果用户没有输入网址则判断是上传文件
                                        formCopy.quote_file_url = this.customerfileArray.toString();
                                    }
                                    if(!this.form.api_doc_url){
                                        formCopy.api_doc_url = this.customerfileArray2.toString();
                                    }
                                    return becomeSupplier(formCopy); // 提交表单
                                })
                                .then(res => {
                                    if (res.code == 1) {
                                        this.current = 0
                                        this.customerfileArray = []
                                        this.customerfileArray2 = []
                                        this.customerSettlementInfoArray = []
                                        this.customerAPIDocumentationInfoArray = []
                                        this.fileList = [],
                                        this.fileList2 = []
                                        this.stopCountdown()
                                        this.form.countryCode = undefined
                                        this.visible = false
                                        this.visible2 = true
                                        this.$refs.ruleForm.resetFields()
                                    } else if (res.code == 1203) {
                                        this.$message.error(res.msg);
                                    } else if (res.code == 1204) {
                                        this.$message.error(res.msg);
                                    } else if (res.code == 1201 || res.code == 1202) {
                                        this.$message.error(res.msg);
                                    }
                                    this.loading = false
                                })
                                .catch(error => {
                                    console.log('提交失败', error);
                                });
                        } else {
                            console.log('err');
                        }
                    });
                }else return
            },
            synchro_otherInputdata(){
                this.form.how_to_know_tsim.other.detail = this.form.other_input
            },
            aboutType_options(value) {
                const inputMapping = {
                    '1': 'social_platform',
                    '2': 'third_party_ecommerce',
                    '3': 'friend_recommendation',
                    '4': 'other'
                };

                Object.keys(inputMapping).forEach((key) => {
                    if(value.includes(key)){
                        this.form.how_to_know_tsim[inputMapping[key]].selected = true;
                    }else if(!value.includes('4')){
                        this.form.how_to_know_tsim[inputMapping[key]].selected = false;
                        this.form.how_to_know_tsim.other.detail = ''
                        this.form.other_input = ''
                    }else{
                        this.form.how_to_know_tsim[inputMapping[key]].detail = '';
                        this.form.how_to_know_tsim[inputMapping[key]].selected = false;
                    }
                });
            },
            chengeCheckBox(value){
                if(!value.includes('2')){
                    this.form.local_options = []
                }
                if(!value.includes('1')){
                    this.form.global_options = []
                }
            },
            changeRadioBox(e){
                if(this.form.support_api==2){
                    this.form.api_doc_url = ''
                    this.fileList2 = []
                    this.customerfileArray2 = []
                    this.customerAPIDocumentationInfoArray = []
                }
            },
            getDisabledDate(current){
                return current > moment().subtract(0, "day"); //今天之后的年月日不可选，不包括今天
            },
            openChangeOne(status) {
                if (status) {
                    this.yearShowOne = true;
                }else{
                    this.yearShowOne = false;
                }
            },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.form.company_create_year = moment(value).format('YYYY')
                this.yearShowOne = false
                this.$nextTick(() => {
                    this.$refs.ruleForm.clearValidate('company_create_year');
                });
            },
            getCode(){
                this.$refs.ruleForm.validateField('contact_email',(valid) => {
                    if (!valid) {
                        sendSupplierEmailVerifyCode({contact_email:this.form.contact_email}).then(res=>{
                            if(res.code==1){
                                this.startCountdown()
                            }
                        })
                    }
                });
            },
            startCountdown() {
                // 如果倒计时已在进行中，则不再启动新的计时
                if (this.isCountingDown) return;

                // 启动倒计时
                this.isCountingDown = true;
                this.timer = setInterval(() => {
                    if (this.countdown > 0) {
                    this.countdown--;
                    } else {
                    this.stopCountdown();
                    }
                }, 1000);
            },
            stopCountdown() {
                // 停止倒计时
                clearInterval(this.timer);
                this.timer = null;
                this.countdown = 60;
                this.isCountingDown = false;
            },
            uploadSettlement() {
                const promises = this.customerSettlementInfoArray.map(item => {
                    return new Promise((resolve, reject) => {
                        const date = new Date();
                        const year = date.getFullYear();
                        const month = date.getMonth() + 1;
                        const directory = 'customerInfoUpload/' + year + '/' + month + '/';
                        const fileName = this.form.company_name + Date.now() + item.file.name;
                        const key = directory + fileName;
                        let formData = new FormData();
                        formData.append('file', item.file.raw || item.file);
                        formData.append('token', this.token);
                        formData.append('key', key);

                        Axios.post('https://up-as0.qiniup.com', formData, {
                            headers: {
                                'Content-type': 'multipart/form-data',
                            },
                        })
                            .then(res => {
                                if (res.status === 200) {
                                    let url = 'https://img.tsimtech.com/' + res.data.url;
                                    this.customerfileArray.push(url);
                                    resolve();
                                } else {
                                    console.log('上传失败');
                                    reject('上传失败');
                                }
                            })
                            .catch(error => {
                                console.log('上传失败', error);
                                reject(error);
                            });
                    });
                });
                return Promise.all(promises); // 等待所有上传操作完成
            },

            uploadAPIDocumentation() {
                const promises = this.customerAPIDocumentationInfoArray.map(item => {
                    return new Promise((resolve, reject) => {
                        const date = new Date();
                        const timestamp = date.getTime();
                        const year = date.getFullYear();
                        const month = date.getMonth() + 1;
                        const directory = 'customerInfoUpload/' + year + '/' + month + '/';
                        const fileName = this.form.company_name + timestamp + item.file.name;
                        const key = directory + fileName;
                        let formData = new FormData();
                        formData.append('file', item.file.raw || item.file);
                        formData.append('token', this.token2);
                        formData.append('key', key);

                        Axios.post('https://up-as0.qiniup.com', formData, {
                            headers: {
                                'Content-type': 'multipart/form-data',
                            },
                        })
                            .then(res => {
                                if (res.status === 200) {
                                    let url = 'https://img.tsimtech.com/' + res.data.url;
                                    this.customerfileArray2.push(url);
                                    resolve();
                                } else {
                                    console.log('上传失败');
                                    reject('上传失败');
                                }
                            })
                            .catch(error => {
                                console.log('上传失败', error);
                                reject(error);
                            });
                    });
                });
                return Promise.all(promises); // 等待所有上传操作完成
            },
            fileStatusChange(file){
                file.fileList.map(item=>{
                    return item.status = 'done'
                })    
                this.fileList = file.fileList
            },
            fileStatusChange2(file){
                file.fileList.map(item=>{
                    return item.status = 'done'
                })    
                this.fileList2 = file.fileList
            },
            beforeUpload(file){
                return new Promise((resolve, reject) => {
                    const isXlsx = file.name.endsWith('.xlsx');
                    if (!isXlsx&&file.type!=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                        this.$message.error(this.$t('collectingInformation.uploadxlsx'));
                        reject(false);
                        return;
                    }
                    getToken().then(response => {
                        this.token = response.result.token
                        resolve()
                    }).catch(err => {
                        reject(false)
                    })
                })
            },
            beforeUpload2(file){
                return new Promise((resolve, reject) => {
                    const isXlsx = file.name.endsWith('.pdf');
                    if (!isXlsx&&file.type!=='application/pdf') {
                        this.$message.error(this.$t('collectingInformation.uploadpdf'));
                        reject(false);
                        return;
                    }
                    getToken().then(response => {
                        this.token2 = response.result.token
                        resolve()
                    }).catch(err => {
                        reject(false)
                    })
                })
            },
            customRequest(file){
                this.customerSettlementInfoArray.push(file);
            },
            customRequest2(file){
                this.customerAPIDocumentationInfoArray.push(file);
            },
            removefile(file){
                this.customerSettlementInfoArray = this.customerSettlementInfoArray.filter(item=>item.file.uid !== file.uid)
                if(!this.customerSettlementInfoArray.length){//当用户提交表单失败时突然把将要上传的全部文档删除了，对应的quote_file_url也要清空
                    this.form.quote_file_url = ''
                    this.customerfileArray = []
                }
            },
            removefile2(file){
                this.customerAPIDocumentationInfoArray = this.customerAPIDocumentationInfoArray.filter(item=>item.file.uid !== file.uid)
                if(!this.customerAPIDocumentationInfoArray.length){//当用户提交表单失败时突然把将要上传的全部文档删除了，对应的api_doc_url也要清空
                    this.form.api_doc_url = ''
                    this.customerfileArray2 = []
                }
            },
        },
    }
</script>

<style lang="less" scoped>
.font-roboto{
        font-family: 'Roboto-Regular';
}
.font-NotoSansTC{
    font-family: 'NotoSansTC-Regular';
}
.titleFont_rb8{
    font-family: 'Roboto-ExtraBold';
}
.titleFont_rb7{
    font-family: 'Roboto-Bold';
}
.titleFont_nt7{
    font-family: 'NotoSansTC-Bold';
}
.titleFont_rb6{
    font-family: 'Roboto-SemiBold';
}
.titleFont_nt6{
    font-family: 'NotoSansTC-SemiBold';
}
.titleFont_rb5{
    font-family: 'Roboto-Medium';
}
.titleFont_nt5{
    font-family: 'NotoSansTC-Medium';
}
.formmodal{
    width: 80%;
    // padding: 0 30px;
    margin: 0 auto;
    margin-top: 20px;
}

/deep/#modalTitle{
    padding-top: 18px;
    padding-bottom: 10px;
    color: #484b4f;
    font-size: 15px;
    border-bottom: 1px solid #e7dfd4;
    span{
        font-size: 20px;
        color: #f49b23;
    }
}

.countryTip{
    margin: -7px 0 6px 0;
    padding-left: 10px;
    color: #8c8c8c;
    line-height: 16px;
    font-size: 14px;
}

.tip{
    margin-top: 15px;
    font-size: 11px;
    line-height: 20px;
    color: #000000;
}

.submitTip{
    line-height: 16px;
    h2{
        font-size: 16px;
        margin-top: 10px;
    }
    span{
        font-size: 14px;
    }
}

.successTip{
    text-align: center;
    padding: 20px;
}

.stepComponent{
    padding-top: 12px;
}

.submitBtn{
    text-align: center;
    .ant-btn{
        width: 97%;
        height: 34px;
        border-color: #f49b23;
        background-color: #f49b23;
        color: #ffffff;
        border-radius: 6px;
        margin: 10px 0;
    }
    .ant-btn:hover, .ant-btn:focus{
        border-color: #f49b23;
    }
    .backBtn{
        .ant-btn{
            border-color: #959595;
            background-color: #f5f7fa;
            color: #959595;
        }
        .ant-btn:hover, .ant-btn:focus{
            border-color: #959595;
        }
    }
}
.defaultBtn{
    .ant-btn{
            // width: 100%;
            border-color: #f5c17a;
            background-color: #f5c17a;
            color: #333333;
            margin-left: 10px;
        }
        .ant-btn:hover, .ant-btn:focus{
            border-color: #f5c17a;
        }
}
.getCodeBtn{
    .ant-btn{
            width: 100%;
            border-color: #f5c17a;
            background-color: #f5c17a;
            color: #333333;
            margin-left: 10px;
        }
        .ant-btn:hover, .ant-btn:focus{
            border-color: #f5c17a;
        }
}
.disabledBtn{
    .ant-btn{
            width: 100%;
            border-color: #f5f7fa;
            background-color: #f5f7fa;
            color: #959595;
        }
        .ant-btn:hover, .ant-btn:focus{
            border-color: #f5f7fa;
        }
}

.checkBox{
    div{
        margin-top: 7px;
    }
    .inBox{
        margin-left: 30px;
        margin-top: 0;
    }
}

.radioTip{
    font-size: 13px;
    padding-left: 21px;
    padding-top: 5px;
}

.divider{
    width: 100px;
    margin: 10px auto;
}

.btnTip{
    padding-left: 12px;
    font-size: 13px;
    padding-top: 5px;
}

.agreementText{
    color: #c86d02;
    text-decoration: underline;
    cursor: pointer;
}

/deep/.ant-modal-header{
    border: 0;
    padding-bottom: 0;
    border-radius: 10px;
}

/deep/.ant-modal-body{
    padding-top: 0px;
}

/deep/.ant-modal-content{
    border-radius: 10px !important;
}


// /deep/label{
//     font-size: 12px;
// }

/deep/.ant-steps-item-title{
    // width: 110px;
    font-size: 12px;
    font-family: 'Roboto-Bold';
    line-height: 15px;
    word-wrap: break-word;
    text-wrap: wrap;
    padding-bottom: 5px;
}


/deep/.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title{
    color: #f49b23;
}


/deep/.ant-steps-item-process .ant-steps-item-icon{
    background-color: #f49b23;
    border-color: #f49b23;
}

/deep/.ant-steps-item-description{
    // width: 100px;
    font-size: 12px;
    line-height: 12px;
}

/deep/.ant-steps-item-icon{
    width: 23px;
    height: 23px;
    line-height:23px;
}

/deep/.ant-select-open .ant-select-selection{
    border-color: #f49b23;
    box-shadow: none;
}

/deep/.ant-select-selection:hover{
    border-color: #f49b23;
}

/deep/.ant-select-dropdown-menu-item .ant-select-dropdown-menu-item-active{
    background-color: #f5c17a !important;
}

/deep/.ant-radio-wrapper{
    margin-bottom: 10px;
}

/deep/.ant-radio-inner{
    border-color: #484b4f;
}

/deep/.ant-radio-inner::after{
    width: 7px !important;
    height: 7px !important;
    top: 3.5px !important;
    left: 3.5px !important;
    background-color: #484b4f !important;
}


/deep/.ant-radio-checked::after{
    border-color: #484b4f;
}

/deep/.ant-radio-input:focus + .ant-radio-inner{
    box-shadow: none;
}



/deep/.ant-input:hover,.ant-input:focus{
    border-color: #f49b23;
    box-shadow: none;
}

/deep/.ant-cascader-picker-show-search .ant-cascader-input.ant-input{
    box-shadow: none;
}

/deep/.ant-calendar-picker-input:hover{
    border-color: #f49b23 !important;
}



/deep/.ant-steps-item-finish .ant-steps-item-icon{
    border-color: #56c568;
}

/deep/.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon{
        color: #56c568;
}

/deep/.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after{
    top: 8px !important;
}
/deep/.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after{
    top: 8px !important;
}

/deep/.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after{
    top: 8px !important;
    background-color: #56c568;
}
/deep/.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after{
    top: 8px !important;
    background-color: #56c568;
}

/deep/.ant-steps-item-tail{
    left: 12px !important;
}

/deep/.ant-checkbox-wrapper{
    margin-left: 0;
    margin: 8px;
}

/deep/.ant-checkbox-checked .ant-checkbox-inner{
    background-color: #484b4f;
    border-color: #484b4f;
}
/deep/.ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner{
    border-color: #484b4f;
}
/deep/.ant-checkbox-checked::after{
    border-color: #484b4f;
}
/deep/.ant-radio-group{
    width: 100%;
}


@media (max-width: 992px){
    /deep/#modalTitle{
        font-size: 15px;
        span{
            font-size: 18px;
        }
    }
    /deep/.ant-steps-item-title{
        font-size: 16px;
    }
    /deep/.ant-steps-item-description{
        width: 100%;
        font-size: 15px;
        line-height: 16px;
    }
    /deep/.ant-steps-item-container{
        height: 62px;
    }
    .tip{
        font-size: 14px;
    }
    .getCodeBtn{
        .ant-btn{
                margin-left: 0px;
                margin-top: 10px;
            }
    }
    .disabledBtn{
        .ant-btn{
                margin-left: 0px;
                margin-top: 10px;
            }
    }
    .submitTip{
        h2{
            font-size: 16px;
        }
        span{
            font-size: 14px;
        }
    }
}


@media (max-width: 767px){
    /deep/.ant-steps-item-container{
        height: 70px;
    }
    .tip{
        margin-top: 5px;
    }
}
</style>